import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import requester from '@/requester';
import store from '@/store';
import { ability } from '@/plugins/casl';

import PainelDeControle from '@/pages/PainelDeControle.vue';
import ErroNaoEncontrado from '@/pages/erro/ErroNaoEncontrado.vue';

import authRoutes from './auth.routes';
import catalisadoresPecas from './catalisadores-pecas.routes';
import catalisadoresPo from './catalisadores-po.routes';
import cotacoesRoutes from './cotacoes.routes';
import familiasRoutes from './familias.routes';
import funcionalidadesRoutes from './funcionalidades.routes';
import gruposRoutes from './grupos.routes';
import lojasRoutes from './lojas.routes';
import pedidosRoutes from './pedidos.routes';
import permissoesRoutes from './permissoes.routes';
import placasRoutes from './placas.routes';
import usuariosRoutes from './usuarios.routes';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    name: 'PainelDeControle',
    component: PainelDeControle,
    meta: {
      icon: 'mdi-view-dashboard',
    },
  },
  ...authRoutes,
  ...catalisadoresPecas,
  ...catalisadoresPo,
  ...cotacoesRoutes,
  ...familiasRoutes,
  ...funcionalidadesRoutes,
  ...gruposRoutes,
  ...lojasRoutes,
  ...pedidosRoutes,
  ...permissoesRoutes,
  ...placasRoutes,
  ...usuariosRoutes,
  {
    path: '*',
    name: 'ErroNaoEncontrado',
    component: ErroNaoEncontrado,
    meta: {
      public: true,
      layout: 'Public',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach(async (to: Route, from: Route, next: NavigationGuardNext) => {
  try {
    // lembrando que store não está persistente, então toda nova página/aba, pegamos as informações do usuário
    const usuarioStore = store.getters.usuario;
    if (!usuarioStore || to.name === 'AuthLogin') {
      // verifica se cookie está com uma sessão válida
      const usuarioCookie = await requester.auth.checkSession();

      ability.update(usuarioCookie.permissoes); // atualiza permissoes
      store.dispatch('login', usuarioCookie); // salva usuario na store
    }

    // se rota for de login e chegou até aqui, é porque já tá logado
    if (to.name === 'AuthLogin' && store.getters.usuario) {
      return next({ name: 'PainelDeControle' });
    }

    // se usuario não tem permissao, redireciona pra home
    const rules = to?.meta?.rules || [];
    if (!rules.every((rule) => ability.can(rule?.action, rule?.subject))) {
      next({ name: 'PainelDeControle' });
      return;
    }

    // tudo certo, segue em frente
    next();
  } catch (err) {
    // verifica se sistema está na versão correta
    const version = err?.response?.headers?.['katalis-version'];
    if (version && version !== localStorage.getItem('katalis-version')) {
      localStorage.setItem('katalis-version', version);
      window.location.reload();
      return;
    }
    // se rota for pública, segue em frente
    if (to?.meta?.public) {
      next();
      return;
    }
    // se não, redireciona pra tela de login
    next({
      name: 'AuthLogin',
      query: { redirect: to.path },
    });
  }
});

export default router;
